import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoText from './InfoText';
import TitleText from './TitleText';
import Empty from '../../assets/images/empty.png';
import classNames from 'classnames';

type Props = {
  disableDesc?: boolean;
  text?: string | React.ReactElement;
  title?: string; // Custom title
  description1?: string; // First description line
  description2?: string; // Second description line
  className?: string;
  imageClassName?: string;
};

export default function EmptyState({
  disableDesc,
  text,
  title,
  description1,
  description2,
  className,
  imageClassName,
}: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        'flex flex-col justify-center items-center text-center py-12 bg-gray-50',
        className
      )}
    >
      <img
        className={classNames('filter grayscale mb-4', imageClassName)}
        src={Empty}
        alt="empty state illustration"
      />

      <div className="empty-content w-3/4 text-center flex flex-col justify-center items-center">
        <TitleText
          size="base"
          className="font-bold font-lg text-gray-900 mb-1"
          text={title || t('emptyTitle')}
        />

        {!disableDesc && (
          <>
            {typeof text === 'string' ? (
              <InfoText
                size="sm"
                text={text || t('emptyText')}
                className="text-gray-500 max-w-md"
              />
            ) : text ? (
              text
            ) : description1 || description2 ? (
              <div className="text-sm text-gray-500 max-w-md">
                {description1 && <p className="mb-1">{description1}</p>}
                {description2 && <p>{description2}</p>}
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
